const DOCUMENT_RECIPIENT_COPIES_TOGGLE_SCOPE = 'document-recipient-copies-toggle';

export const DocumentRecipientCopiesToggleTestIds = {
  getToggleId: documentId => `${DOCUMENT_RECIPIENT_COPIES_TOGGLE_SCOPE}.toggle-${documentId}`,
};
